import { createIcon } from './create-icon';

export type { IconProps } from './create-icon';

export const HomeIcon = createIcon(
  <>
    <path d="M3 12L12 4l9 8" />
    <path d="M5 10.5V19a1 1 0 001 1h4v-5h4v5h4a1 1 0 001-1v-8.5" />
  </>,
  'HomeIcon',
);

export const SearchIcon = createIcon(
  <>
    <circle cx="11" cy="11" r="7" />
    <path d="M17 17l4 4" />
  </>,
  'SearchIcon',
);

export const LibraryIcon = createIcon(
  <>
    <path d="M4 19.5A2.5 2.5 0 016.5 17H20" />
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" />
  </>,
  'LibraryIcon',
);

export const HeartIcon = createIcon(
  <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" />,
  'HeartIcon',
);

export const GridIcon = createIcon(
  <>
    <rect x="3" y="3" width="7" height="7" rx="1.5" />
    <rect x="14" y="3" width="7" height="7" rx="1.5" />
    <rect x="3" y="14" width="7" height="7" rx="1.5" />
    <rect x="14" y="14" width="7" height="7" rx="1.5" />
  </>,
  'GridIcon',
);

export const MessageIcon = createIcon(
  <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />,
  'MessageIcon',
);

export const UserIcon = createIcon(
  <>
    <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </>,
  'UserIcon',
);

export const SettingsIcon = createIcon(
  <>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z" />
  </>,
  'SettingsIcon',
);

export const BookmarkIcon = createIcon(
  <path d="M19 21l-7-5-7 5V5a2 2 0 012-2h10a2 2 0 012 2z" />,
  'BookmarkIcon',
);

export const BellIcon = createIcon(
  <>
    <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 01-3.46 0" />
  </>,
  'BellIcon',
);

export const ArrowLeftIcon = createIcon(
  <path d="M19 12H5M12 5l-7 7 7 7" />,
  'ArrowLeftIcon',
);

export const ArrowRightIcon = createIcon(
  <path d="M5 12h14M12 5l7 7-7 7" />,
  'ArrowRightIcon',
);

export const ChevronDownIcon = createIcon(
  <path d="M6 9l6 6 6-6" />,
  'ChevronDownIcon',
);

export const ChevronUpIcon = createIcon(
  <path d="M18 15l-6-6-6 6" />,
  'ChevronUpIcon',
);

export const ChevronRightIcon = createIcon(
  <path d="M9 18l6-6-6-6" />,
  'ChevronRightIcon',
);

export const CalendarIcon = createIcon(
  <>
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <path d="M16 2v4M8 2v4M3 10h18" />
  </>,
  'CalendarIcon',
);

export const PlusCircleIcon = createIcon(
  <>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 8v8M8 12h8" strokeLinecap="round" />
  </>,
  'PlusCircleIcon',
);

export const GlobeIcon = createIcon(
  <>
    <circle cx="12" cy="12" r="9" />
    <path d="M2 12h20M12 2a15.3 15.3 0 010 20M12 2a15.3 15.3 0 000 20" />
  </>,
  'GlobeIcon',
);

export const PencilIcon = createIcon(
  <>
    <path d="M12 20h9" />
    <path d="M16.5 3.5a2.12 2.12 0 013 3L7 19l-4 1 1-4 12.5-12.5z" />
  </>,
  'PencilIcon',
);

export const LogOutIcon = createIcon(
  <>
    <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" />
    <path d="M16 17l5-5-5-5M21 12H9" />
  </>,
  'LogOutIcon',
);

export const ShuffleIcon = createIcon(
  <>
    <path d="M16 3h5v5M4 20L21 3M21 16v5h-5M15 15l6 6M4 4l5 5" />
  </>,
  'ShuffleIcon',
);

export const XIcon = createIcon(
  <path d="M18 6L6 18M6 6l12 12" />,
  'XIcon',
);

export const ConstellationIcon = createIcon(
  <>
    <path d="M5 18l5-7 5 3 4-8" />
    <circle cx="5" cy="18" r="1.6" />
    <circle cx="10" cy="11" r="1.6" />
    <circle cx="15" cy="14" r="1.6" />
    <circle cx="19" cy="6" r="1.6" />
  </>,
  'ConstellationIcon',
);

export const TrashIcon = createIcon(
  <>
    <path d="M4 7h16" />
    <path d="M9 7V4.5A1.5 1.5 0 0110.5 3h3A1.5 1.5 0 0115 4.5V7" />
    <path d="M6 7l1 12.5A1.5 1.5 0 008.5 21h7a1.5 1.5 0 001.5-1.5L18 7" />
    <path d="M10 11v6M14 11v6" />
  </>,
  'TrashIcon',
);
